<template>
  <div>
    
  </div>
</template>

<script>
  import Uploader from './Uploader'
  export default {
    props: ['form', 'collection', 'extensions', 'size'],
    components: {
      Uploader
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ui/FileUploaderTable.vue